import axios from 'axios';
import { getToken, removeToken } from './auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 60000, // 60 second default timeout
});

// Request interceptor - add auth token
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - handle 401 errors (expired/invalid token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid or expired - clear auth and redirect to home
      const currentPath = window.location.pathname;
      // Only redirect if on a protected route (dashboard pages)
      if (currentPath.includes('/dashboard') || 
          currentPath.includes('/teacher/') || 
          currentPath.includes('/student/') || 
          currentPath.includes('/admin/') ||
          currentPath.includes('/learn/') ||
          currentPath.includes('/chat')) {
        removeToken();
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;